const Types = {
  FETCH_PERMISSIONS: '@users/FETCH_PERMISSIONS',
  FETCH_PERMISSIONS_SUCCESS: '@users/FETCH_PERMISSIONS_SUCCESS',
};

export default Types;
